// extracted by mini-css-extract-plugin
export default {"upload":"upload---vQa3y","uploadTitle":"uploadTitle---DO1Mx","activeUpload":"activeUpload---OFozV","activeUploadTitle":"activeUploadTitle---aBUlq"};